import { FC, ReactNode } from 'react';

interface SectionProps {
  title: string;
  children: ReactNode;
}

/**
 * A titled block: uppercase teal heading, short keyline, content.
 * Sections are allowed to break across pages; their entries are not
 * (see print.css).
 */
export const Section: FC<SectionProps> = ({ title, children }) => (
  <section className="cv-section">
    <div className="cv-section-title">
      <h2>{title}</h2>
      <div className="cv-keyline" />
    </div>
    {children}
  </section>
);

export default Section;
